import { gql } from '@apollo/client';

const atlSponsorRankingsFragment = gql`
  fragment AtlSponsorRankingsFields on AppraiserEventAtlSponsorRankings {
    Appraiser {
      ExternalUserId
      Name
      CurrentRoleName
    }
    EventBid {
      Id
      BidDate
    }
    SponsorRanking {
      Rank
    }
    NumOfEventsBeforeAfter
    AtlAvailability
  }
`;

export default atlSponsorRankingsFragment;
